$(document).ready(function($) {
    $('.accordion .label').click(function() {
        $(this).parent().toggleClass('active');
    });
});